import { render, staticRenderFns } from "./outofofficeRequests.vue?vue&type=template&id=6097e5ed&"
import script from "./outofofficeRequests.vue?vue&type=script&lang=js&"
export * from "./outofofficeRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports